import { Box, Grid } from '@mui/material';
import { memo } from 'react';
import ProjectResultInfo from './ProjectResultInfo';

function Stepper5(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Box sx={{ px: '1.625rem' }}>
        <Grid
          container
          spacing={2}
          sx={{
            mt: '1.5rem',
            width: '100%',
            display: 'flex',
            justifyContent: { xs: 'flex-start', lg: 'center' },
          }}
        >
          <Grid item xs={12} sm={8} lg={6}>
            <ProjectResultInfo type="inputs" />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

export default memo(Stepper5);
